import { Component, OnInit } from '@angular/core';
import { ShellUpdateService, ShellUpdateMessage, ShellActionMessage } from '../../services/shell-update-service/shell-update.service';
import { AppConfigService } from '../../services/app-config-service/app-config.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admin-view',
  templateUrl: './portal-admin.component.html',
  styleUrls: ['./portal-admin.component.css']
})
export class PortalAdminViewComponent implements OnInit {

  constructor(private shellUpdateService: ShellUpdateService,
    private appConfigService: AppConfigService, private router: Router) { }

  ngOnInit() {
    this.shellUpdateService.sendShellUpdateMessage(new ShellUpdateMessage(
      this.appConfigService.ApplicationName, "PATIENT SEARCH", null, null));

    this.shellUpdateService.sendShellUpdateActionMessage(new ShellActionMessage(false, false, true,false, true));
  }

}



// WEBPACK FOOTER //
// ./src/app/views/portal-admin-view/portal-admin.component.ts